import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Card, Form, Button, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LunchPlanWaiverFormComp from '../../../../components/registrationPacket/LunchPlanWaiverFormComp';

const LunchPlanWaiverForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = Boolean(id);

  useEffect(() => {

  }, []);

  return (
    <Container>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title">
                <h4 className="card-title">
                  {isEditMode ? 'Edit' : 'Create'} Lunch Plan Waiver
                </h4>
              </div>
              <Button variant="secondary" size="sm" onClick={() => navigate('/dashboard/lunch-plan-waiver/list')}>
                <i className="icon material-symbols-outlined me-1" style={{ verticalAlign: 'middle' }}>arrow_back</i>
                Back to List
              </Button>
            </Card.Header>
            <Card.Body>
              <LunchPlanWaiverFormComp isEditMode={isEditMode} existingData={""} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LunchPlanWaiverForm;
